// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"420":"2dcb7c50","453":"18063562","685":"e631eb1e","705":"776d028b"}[chunkId] + ".chunk.js";
};